/*eslint-disable react/no-unknown-property */
/*eslint-disable no-useless-constructor */

/*eslint-disable array-callback-return */

/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState, createRef } from 'react';
import { Container, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../common/Header/Header';
import { HorizontalDivider } from 'src/Admin/components/common/HorizontalDivider';
import { ActionMenus } from '../../common/ActionMenu';

import GenericButton from '../../common/button/GenericButton/GenericButton';
import TextInput from 'src/Admin/components/common/text-input';
import { SearchSVG } from 'src/Admin/img/SearchSVG';
import TrashIcon from 'src/Admin/img/search-claims/trash';
import CarrotDownIcon from 'src/Admin/img/search-claims/carrot-down';
import CheckboxInput from 'src/Member/components/common/checkbox';
import {
  valuesList,
  criteriaMenuItems,
  memberTypeOptions,
  criteriaDefaultValues,
  providerTypeOptions,
  searchByProviderOptions,
  claimDateSearchByOptions,
  claimDateDateRangeOptions,
} from '../values-list';
import AutoSuggestionSelectComponent from '../../common/AutoSuggestSelect/Select';
//#TODO: use below component for search sugesstions on Specialties
import DatePicker from '../../common/DatePicker';

import ClaimListFilter from './ClaimListFilter';
import ClaimListGrid from './ClaimListGrid';

import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import moment from 'moment';
import 'react-web-tabs/dist/react-web-tabs.css';
import './searchClaims.scss';
import BackArrow from 'src/Admin/img/arrow_back.svg';

const ManageClaims = (props) => {
  const {
    searchParms: { pageSize: pageSizeStore, pageNumber, sortBy: sortByColumn },
    claimsResult,
    activeUserOID,
  } = useSelector(({ claims }) => claims);

  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting,
  );
  console.log('Default_Time_Format', Default_Time_Format);
  //GET REdux state
  const loggedInUserDetails = useSelector(({ user }) => user?.userData);
  const [filteredClaimsData, setFilteredClaimsData] = useState([]);
  const [searchCriteriaData, setSearchCriteriaData] = useState({});

  const showCriteriaArray = (criteriaArray) => {
    const remainingItems = criteriaArray.slice(1, criteriaArray.length);
    const status =
      remainingItems.length > 0
        ? criteriaArray[0].label + ' +' + remainingItems.length
        : criteriaArray[0].label;
    return status;
  };
  //pagination specific states start
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(pageSizeStore);
  const [currentPage, setCurrentPage] = useState(pageNumber);
  const [dataFetching, setDataFetching] = useState(true);

  //pagination specific states end

  const showClaimLable = (arr) => {
    const showClaimDateLabel = [];
    arr.forEach((obj, i) => {
      if (obj.type !== null || obj.date_range !== null) {
        if (obj.type?.value) showClaimDateLabel.push(true);
      }
    });
    return showClaimDateLabel.length > 0;
  };

  const getSortColumn = () => {
    let strParams = '';
    let sortDirection;

    const sortByMap = {
      TotalPaid: 'totpaid',
      PatientResponsibility: 'totpatresp',
      TotalCharge: 'totcharge',
      PatientName: 'patientfirstname',
      ProviderName: 'providerfirstname',
      ClaimStatus: 'claimstatus',
    };

    if (sortByColumn && sortByColumn[0] && sortByColumn[0]?.id) {
      sortDirection = sortByColumn[0]?.desc ? 'desc' : 'asc';
      if (sortByMap[sortByColumn[0]?.id]) {
        strParams += `/sortby/${
          sortByMap[sortByColumn[0]?.id]
        }/sortdirection/${sortDirection}`;
      } else {
        strParams += `/sortby/${sortByColumn[0]?.id}/sortdirection/${sortDirection}`;
      }
    }
    return strParams;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const { providerSelectedValue, memberSelectedValue } = location.state || {};
  const Specialty = providerSelectedValue
    ? providerSelectedValue[0]?.Specialty &&
      providerSelectedValue[0]?.Specialty.split(',').map((item) => item?.trim())
    : [];

  useEffect(() => {
    console.log('search params', location.state);
    const { paramsUrl, searchCriteria } = location.state || {};
    setSearchCriteriaData(searchCriteria);
    const searchClaims = async () => {
      /*return await axiosInstance.get(
        `${APIEndpoints.searchClaimsIndependently()}${paramsUrl}/pageSize/200`,
      ); */ //actual URL to be used
      return await axiosInstance.get(
        `${APIEndpoints.searchClaimsIndependently()}pagenumber/${currentPage}/pageSize/${pageSize}${getSortColumn()}${paramsUrl}`,
      ); //actual URL to be used
      //return await axiosInstance.get(`${APIEndpoints.searchClaimsIndependently()}/pagenumber/${currentPage}/pageSize/${pageSize}/Product/MM,DE`);
    };

    (async () => {
      try {
        const resourceData = await searchClaims();
        console.log('******************************', resourceData);
        if (resourceData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
          setFilteredClaimsData(resourceData?.data?.Response?.Claims);
          setTotalRecords(
            resourceData?.data?.Response?.Pagination?.TotalRecords,
          );
          setDataFetching(false);
        }

        //setOldRowsData( [ ...resourceList ] );
      } catch (error) {
        console.error(error);
        setFilteredClaimsData([]);
        setTotalRecords(0);
        setDataFetching(false);
      } finally {
        //setLoader( false );
      }
    })();
  }, [currentPage, pageSize, sortByColumn]);
  console.log('searchCriteriaData', providerSelectedValue, searchCriteriaData);
  return (
    <div>
      <div fluid className="manage-claims container-offset">
        <Row>
          <Col>
            <Header
              linkTo={'/admin/search-claims'}
              header={'Claims'}
              preserveData={location.state}
            />
          </Col>
        </Row>
        <div
          className="search-results-header main-wrapper d-flex justify-content-between mt-3"
          style={{ marginTop: '32px' }}
        >
          <div className="top">
            <div className="top-container">
              <div>
                {searchCriteriaData &&
                  (searchCriteriaData['claim-number'] ||
                    (searchCriteriaData['claim-status'] &&
                      searchCriteriaData['claim-status'].length > 0) ||
                    (searchCriteriaData['products'] &&
                      searchCriteriaData['products'].length > 0) ||
                    searchCriteriaData['sccf']) && (
                    <div className="service-provider">
                      <div className="text-container">Claim</div>
                      <div className="flex-container">
                        {searchCriteriaData &&
                          searchCriteriaData['claim-number'] && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                Claim Number:
                              </span>
                              <span className="search-result-data-value">
                                {searchCriteriaData &&
                                searchCriteriaData['claim-number']
                                  ? searchCriteriaData['claim-number']
                                  : '-'}
                              </span>
                            </div>
                          )}

                        {searchCriteriaData &&
                          searchCriteriaData['claim-status'] &&
                          searchCriteriaData['claim-status'].length > 0 && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                Claim Status:
                              </span>
                              <span className="search-result-data-value">
                                {searchCriteriaData &&
                                searchCriteriaData['claim-status']
                                  ? showCriteriaArray(
                                      searchCriteriaData['claim-status'],
                                    )
                                  : '-'}
                              </span>
                            </div>
                          )}

                        {searchCriteriaData &&
                          searchCriteriaData['products'] &&
                          searchCriteriaData['products'].length > 0 && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                Products:
                              </span>
                              <span className="search-result-data-value">
                                {searchCriteriaData &&
                                searchCriteriaData['products']
                                  ? showCriteriaArray(
                                      searchCriteriaData['products'],
                                    )
                                  : '-'}
                              </span>
                            </div>
                          )}

                        {searchCriteriaData && searchCriteriaData['sccf'] && (
                          <div className="search-result-data">
                            <span className="search-result-data-heading">
                              SCCF Number:
                            </span>
                            <span className="search-result-data-value">
                              {searchCriteriaData && searchCriteriaData['sccf']
                                ? searchCriteriaData['sccf']
                                : '-'}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                {(searchCriteriaData || memberSelectedValue) &&
                  ((memberSelectedValue[0]?.MemberType &&
                    memberSelectedValue[0]?.MemberType !== null &&
                    memberSelectedValue[0]?.MemberType !== '') ||
                    (memberSelectedValue[0]?.memberID &&
                      memberSelectedValue[0]?.memberID !== null &&
                      memberSelectedValue[0]?.memberID !== '') ||
                    ((memberSelectedValue[0]?.FirstName ||
                      memberSelectedValue[0]?.LastName) &&
                      (memberSelectedValue[0]?.FirstName ||
                        memberSelectedValue[0]?.LastName) !== null &&
                      (memberSelectedValue[0]?.FirstName ||
                        memberSelectedValue[0]?.LastName) !== '')) && (
                    <div className="service-provider">
                      <div className="text-container">Member</div>

                      <div className="flex-container">
                        {/*{searchCriteriaData &&
                          searchCriteriaData['member-information'] &&
                          searchCriteriaData['member-information'][0]
                            .member_id !== null &&
                          searchCriteriaData['member-information'][0]
                            .member_id !== '' && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                Member ID:
                              </span>
                              <span className="search-result-data-value">
                                {searchCriteriaData &&
                                searchCriteriaData['member-information'] &&
                                searchCriteriaData['member-information'][0]
                                  .member_id !== null
                                  ? searchCriteriaData['member-information'][0]
                                      .member_id
                                  : '-'}
                              </span>
                            </div>
                          )} */}
                        {memberSelectedValue[0] &&
                          (memberSelectedValue[0]?.FirstName ||
                            memberSelectedValue[0]?.LastName) &&
                          (memberSelectedValue[0]?.FirstName ||
                            memberSelectedValue[0]?.LastName) !== null &&
                          (memberSelectedValue[0]?.FirstName ||
                            memberSelectedValue[0]?.LastName) !== '' && (
                            <div className="search-result-data">
                              <span className="search-result-data-value">
                                {(memberSelectedValue[0]?.FirstName ||
                                  memberSelectedValue[0]?.LastName) &&
                                (memberSelectedValue[0]?.FirstName ||
                                  memberSelectedValue[0]?.LastName) !== null &&
                                (memberSelectedValue[0]?.FirstName ||
                                  memberSelectedValue[0]?.LastName) !== ''
                                  ? memberSelectedValue[0]?.FirstName +
                                    ' ' +
                                    memberSelectedValue[0]?.LastName
                                  : '-'}
                              </span>
                            </div>
                          )}
                        {memberSelectedValue[0] &&
                          memberSelectedValue[0]?.MemberType &&
                          memberSelectedValue[0]?.MemberType !== null &&
                          memberSelectedValue[0]?.MemberType !== '' && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                User Type:
                              </span>
                              <span className="search-result-data-value">
                                {memberSelectedValue[0]?.MemberType &&
                                memberSelectedValue[0]?.MemberType !== null &&
                                memberSelectedValue[0]?.MemberType !== ''
                                  ? memberSelectedValue[0]?.MemberType
                                  : '-'}
                              </span>
                            </div>
                          )}
                        {memberSelectedValue[0] &&
                          memberSelectedValue[0]?.memberID &&
                          memberSelectedValue[0]?.memberID !== null &&
                          memberSelectedValue[0]?.memberID !== '' && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                Member ID:
                              </span>
                              <span className="search-result-data-value">
                                {memberSelectedValue[0]?.memberID &&
                                memberSelectedValue[0]?.memberID !== null &&
                                memberSelectedValue[0]?.memberID !== ''
                                  ? memberSelectedValue[0]?.memberID
                                  : '-'}
                              </span>
                            </div>
                          )}
                        {memberSelectedValue[0] &&
                          memberSelectedValue[0]?.BirthDate &&
                          memberSelectedValue[0]?.BirthDate !== null &&
                          memberSelectedValue[0]?.BirthDate !== '' && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                DOB:
                              </span>
                              <span className="search-result-data-value">
                                {memberSelectedValue[0]?.BirthDate &&
                                memberSelectedValue[0]?.BirthDate !== null &&
                                memberSelectedValue[0]?.BirthDate !== ''
                                  ? moment(
                                      memberSelectedValue[0]?.BirthDate,
                                    ).format(Default_Time_Format)
                                  : '-'}
                              </span>
                            </div>
                          )}

                        {searchCriteriaData &&
                          searchCriteriaData['member-information'] &&
                          searchCriteriaData['member-information'][0]
                            .patient_control_number !== null &&
                          searchCriteriaData['member-information'][0]
                            .patient_control_number !== '' && (
                            <div className="search-result-data">
                              <span className="search-result-data-heading">
                                Patient Control Number:
                              </span>
                              <span className="search-result-data-value">
                                {searchCriteriaData &&
                                searchCriteriaData['member-information'] &&
                                searchCriteriaData['member-information'][0]
                                  .patient_control_number !== null
                                  ? searchCriteriaData['member-information'][0]
                                      .patient_control_number
                                  : '-'}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                {providerSelectedValue[0] && (
                  <>
                    {!providerSelectedValue[0].isdummy ? (
                      <>
                        {((providerSelectedValue[0].FirstName &&
                          providerSelectedValue[0].FirstName !== '' &&
                          providerSelectedValue[0].FirstName !== null) ||
                          (providerSelectedValue[0].MiddleName &&
                            providerSelectedValue[0].MiddleName !== '' &&
                            providerSelectedValue[0].MiddleName !== null) ||
                          (providerSelectedValue[0].LastName &&
                            providerSelectedValue[0].LastName !== '' &&
                            providerSelectedValue[0].LastName !== null) ||
                          Specialty.length > 0 ||
                          (providerSelectedValue[0].Physician_NPI &&
                            providerSelectedValue[0].Physician_NPI !== '' &&
                            providerSelectedValue[0].Physician_NPI !== null) ||
                          (providerSelectedValue[0].TaxID &&
                            providerSelectedValue[0].TaxID !== '' &&
                            providerSelectedValue[0].TaxID !== null)) && (
                          <div className="service-provider">
                            <div className="text-container">Provider</div>
                            <div className="flex-container">
                              {providerSelectedValue[0] &&
                                ((providerSelectedValue[0].FirstName &&
                                  providerSelectedValue[0].FirstName !== '' &&
                                  providerSelectedValue[0].FirstName !==
                                    null) ||
                                  (providerSelectedValue[0].MiddleName &&
                                    providerSelectedValue[0].MiddleName !==
                                      '' &&
                                    providerSelectedValue[0].MiddleName !==
                                      null) ||
                                  (providerSelectedValue[0].LastName &&
                                    providerSelectedValue[0].LastName !== '' &&
                                    providerSelectedValue[0].LastName !==
                                      null)) && (
                                  <div className="search-result-data">
                                    {/*<span className="search-result-data-heading">
                                Doctor Name:
                              </span> */}
                                    <span className="search-result-data-value">
                                      {providerSelectedValue[0].FirstName +
                                        ' ' +
                                        providerSelectedValue[0].MiddleName +
                                        ' ' +
                                        providerSelectedValue[0].LastName}
                                    </span>
                                  </div>
                                )}
                              {providerSelectedValue[0] &&
                                Specialty.length > 0 && (
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      Specialties:
                                    </span>
                                    <span className="search-result-data-value">
                                      {Specialty[0] && (
                                        <span>{Specialty[0]}</span>
                                      )}
                                      {Specialty[1] && (
                                        <span>, {Specialty[1]}</span>
                                      )}
                                      {Specialty.length > 2 && (
                                        <span> +{Specialty.length - 2}</span>
                                      )}
                                    </span>
                                  </div>
                                )}
                              {providerSelectedValue[0] &&
                                providerSelectedValue[0].Physician_NPI &&
                                providerSelectedValue[0].Physician_NPI !== '' &&
                                providerSelectedValue[0].Physician_NPI !==
                                  null && (
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      NPI:
                                    </span>
                                    <span className="search-result-data-value">
                                      {providerSelectedValue[0].Physician_NPI}
                                    </span>
                                  </div>
                                )}
                              {providerSelectedValue[0] &&
                                providerSelectedValue[0].TaxID &&
                                providerSelectedValue[0].TaxID !== '' &&
                                providerSelectedValue[0].TaxID !== null && (
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      Tax ID:
                                    </span>
                                    <span className="search-result-data-value">
                                      {providerSelectedValue[0].TaxID}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {((providerSelectedValue[0].FaciltyName &&
                          providerSelectedValue[0].FaciltyName !== '' &&
                          providerSelectedValue[0].FaciltyName !== null) ||
                          Specialty.length > 0 ||
                          (providerSelectedValue[0].Facility_NPI &&
                            providerSelectedValue[0].Facility_NPI !== '' &&
                            providerSelectedValue[0].Facility_NPI !== null) ||
                          (providerSelectedValue[0].TaxID &&
                            providerSelectedValue[0].TaxID !== '' &&
                            providerSelectedValue[0].TaxID !== null)) && (
                          <div className="service-provider">
                            <div className="text-container">Provider</div>
                            <div className="flex-container">
                              {providerSelectedValue[0] &&
                                providerSelectedValue[0].FaciltyName &&
                                providerSelectedValue[0].FaciltyName !== '' &&
                                providerSelectedValue[0].FaciltyName !==
                                  null && (
                                  <div className="search-result-data">
                                    {/*<span className="search-result-data-heading">
                                    Doctor Name:
                                  </span> */}
                                    <span className="search-result-data-value">
                                      {providerSelectedValue[0].FaciltyName}
                                    </span>
                                  </div>
                                )}
                              {providerSelectedValue[0] &&
                                Specialty.length > 0 && (
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      Specialties:
                                    </span>
                                    <span className="search-result-data-value">
                                      {Specialty[0] && (
                                        <span>{Specialty[0]}</span>
                                      )}
                                      {Specialty[1] && (
                                        <span>, {Specialty[1]}</span>
                                      )}
                                      {Specialty.length > 2 && (
                                        <span> +{Specialty.length - 2}</span>
                                      )}
                                    </span>
                                  </div>
                                )}
                              {providerSelectedValue[0] &&
                                providerSelectedValue[0].Facility_NPI &&
                                providerSelectedValue[0].Facility_NPI !== '' &&
                                providerSelectedValue[0].Facility_NPI !==
                                  null && (
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      NPI:
                                    </span>
                                    <span className="search-result-data-value">
                                      {providerSelectedValue[0].Facility_NPI}
                                    </span>
                                  </div>
                                )}
                              {providerSelectedValue[0] &&
                                providerSelectedValue[0].TaxID &&
                                providerSelectedValue[0].TaxID !== '' &&
                                providerSelectedValue[0].TaxID !== null && (
                                  <div className="search-result-data">
                                    <span className="search-result-data-heading">
                                      Tax ID:
                                    </span>
                                    <span className="search-result-data-value">
                                      {providerSelectedValue[0].TaxID}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
                {searchCriteriaData &&
                  searchCriteriaData['claim-date'] &&
                  showClaimLable(searchCriteriaData['claim-date']) && (
                    <div className="service-provider">
                      <div className="text-container">Claim Date</div>
                      <div>
                        {searchCriteriaData &&
                          searchCriteriaData['claim-date'] &&
                          searchCriteriaData['claim-date'].map(
                            (claimDate, index) => (
                              <>
                                {claimDate.type?.value && (
                                  <>
                                    <div
                                      className="flex-container mb-2"
                                      key={`claim-${index}`}
                                    >
                                      {claimDate && claimDate.type !== null && (
                                        <div className="search-result-data">
                                          {/*claimDate &&
                                  claimDate.date_range !== null &&
                                  searchCriteriaData['claim-date'].length >
                                    1 && (
                                    <span className="search-result-data-value">{`DATE ${
                                      index + 1
                                    }`}</span>
                                  )*/}
                                          {/*<span className="search-result-data-heading">
                                  Type:
                                </span>*/}

                                          <span className="search-result-data-heading">
                                            Type:
                                          </span>
                                          <span className="search-result-data-value">
                                            {claimDate.type.label}
                                          </span>
                                        </div>
                                      )}
                                      {claimDate &&
                                        claimDate.date_range !== null && (
                                          <div className="search-result-data">
                                            <span className="search-result-data-heading">
                                              Duration:
                                            </span>
                                            <span className="search-result-data-value">
                                              {claimDate &&
                                              claimDate.date_range !== null
                                                ? claimDate.date_range.label ===
                                                  'Custom Date'
                                                  ? `${moment(
                                                      claimDate.from_date,
                                                    ).format(
                                                      Default_Time_Format,
                                                    )} - ${moment(
                                                      claimDate.to_date,
                                                    ).format(
                                                      Default_Time_Format,
                                                    )}`
                                                  : claimDate.date_range.label
                                                : '-'}
                                            </span>
                                          </div>
                                        )}
                                    </div>
                                  </>
                                )}
                              </>
                            ),
                          )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>

          <div className="button-container">
            <div className="modify-btn-container">
              <GenericButton
                className="modify-filter-btn"
                variant="secondary"
                onClick={() => {
                  navigate('/admin/search-claims', {
                    state: location.state,
                  });
                  //setModify(!modify);
                }}
              >
                Modify Search
              </GenericButton>
            </div>
          </div>
        </div>
      </div>
      {/*<div fluid className="manage-claims container-offset">
        <Row>
          <Col>
            <Header
              linkTo={'/admin/search-claims'}
              header={'Claims'}
              preserveData={location.state}
            />
          </Col>
        </Row>
        <Row className="search-results-header" style={{ marginTop: '32px' }}>
          <Col md={3}>
            <label>Claim No : </label>{' '}
            <span>
              {searchCriteriaData && searchCriteriaData['claim-number']
                ? searchCriteriaData['claim-number']
                : '-'}
            </span>
          </Col>
          <Col md={3}>
            <label>Products : </label>{' '}
            <span>
              {searchCriteriaData && searchCriteriaData['products']
                ? showCriteriaArray(searchCriteriaData['products'])
                : '-'}
            </span>
          </Col>
          <Col md={3}>
            <label>Member ID : </label> <span>1234567890</span>
          </Col>
          <Col md={3}>
            <label>Provider Type : </label>{' '}
            <span>
              {searchCriteriaData && searchCriteriaData['provider-information']
                ? searchCriteriaData['provider-information'][0].type.label
                : '-'}
            </span>
          </Col>
          <Col md={3}>
            <label>Claim Status : </label>{' '}
            <span>
              {searchCriteriaData && searchCriteriaData['claim-status']
                ? showCriteriaArray(searchCriteriaData['claim-status'])
                : '-'}
            </span>
          </Col>
          <Col md={3}>
            <label>SCCF# : </label>{' '}
            <span>
              {searchCriteriaData && searchCriteriaData['sccf']
                ? searchCriteriaData['sccf']
                : '-'}
            </span>
          </Col>
          <Col md={3}>
            <label>Name : </label> <span>1234567890</span>
          </Col>
          <Col md={3}>
            <label>Search By : </label>{' '}
            <span>
              {searchCriteriaData && searchCriteriaData['provider-information']
                ? searchCriteriaData['provider-information'][0].search_by.label
                : '-'}
            </span>
          </Col>
        </Row>
        <Row className="search-results-header">
          {searchCriteriaData &&
            searchCriteriaData['claim-date'] &&
            searchCriteriaData['claim-date'].map((claimDate, index) => (
              <Col md={3} key={`col-${index}`}>
                <div>
                  <label>{`DATE ${index + 1}`}</label>
                </div>
                <div>
                  <label>Type : </label> <span>{claimDate.type.label}</span>
                </div>
                <div>
                  <label>Duration : </label>{' '}
                  <span>
                    {claimDate.date_range.label === 'Custom Date'
                      ? `${moment(claimDate.date_from).format(
                          Default_Time_Format,
                        )} - ${moment(claimDate.date_to).format(
                          Default_Time_Format,
                        )}`
                      : claimDate.date_range.label}
                  </span>
                </div>
              </Col>
            ))}
        </Row>
                        </div>*/}
      {/*<div className="claims-info">
        <div className="claims-list-page">
          <div className="claims-list-page-filters filter-bar-border-top filter-bar-border-bottom mt-4 mb-4">
            <div className="container-offset">
              <ClaimListFilter />
            </div>
          </div>
        </div>
      </div> */}
      <div className="container-offset">
        <HorizontalDivider className="divider" />
      </div>
      <div className="container-offset">
        <Row className="mt-4 claims-list-grid">
          <ClaimListGrid
            dataFetching={dataFetching}
            isAPIFailed={false}
            filteredClaimsData={filteredClaimsData}
            preserveData={location.state}
            selectedUserFirstName={loggedInUserDetails?.FirstName || ''}
            selectedUserEmail={loggedInUserDetails?.UserID || ''}
            totalRecords={totalRecords}
            setTotalRecords={setTotalRecords}
            pageSize={pageSize}
            setPageSize={setPageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageSizeStore={pageSizeStore}
            pageNumber={pageNumber}
            sortByColumn={sortByColumn}
          />
        </Row>
      </div>
      <div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          autoClose={5000}
          position="top-center"
          newestOnTop={false}
          hideProgressBar={false}
          className="toastcontainer"
        />
      </div>
    </div>
  );
};

export default withTranslation()(ManageClaims);
